import { Discount, OrderItem, OrderStatusType, ShippableBase } from "./order.types"
import { FulfillmentRefundInfo, RefundPublic } from "./refund.types"
import { ReviewForEdit } from "./review.types"

export type ShippingType = "Free Shipping"
 | "Fixed Price"
 | "Standard"
 | "Digital Download"

export interface ShippingTypeInfo {
  label: ShippingType
  hint?: string
}

export interface ShippingInfo extends ShippableBase {
  compressionRate?: number
  type: ShippingType
}

export interface Parcel extends ShippableBase {
  id: string
  shippingProcessorParcelId?: string
  fulfillmentId: string
  name: string
  refundId: string
  orderItems_on_parcel: OrderItem[]
}

export type ShippingWeightUnit = "g" | "kg" | "lb" | "oz"
export type ShippingDistanceUnit = "cm" | "in" | "ft" | "m" | "mm" | "yd"
export const shipmentWeightUnitList: ShippingWeightUnit[] = ["lb", "oz", "g", "kg", ]
export const shipmentDistanceUnitList: ShippingDistanceUnit[] = ["in", "ft", "mm", "cm",  "m", "yd"]

export type FulfillmentStatusType = "required"
  | "waiting"
  | "delinquency"
  | "terminated"
  | "fulfilling"
  | "shipping"
  | "delayed"
  | "incident"
  | "delivered"
  | "arrived"
  | "review"
  | "downloadable"
  | "archived"

export type PayoutStatusType = "pending"
  | "deferred"
  | "queued"
  | "failed"
  | "cancelled"
  | "posted"
  | "returned"
  | "processing"

export const nonShippedFulfillmentStatuses: FulfillmentStatusType[] = ["required", "waiting", "delinquency", "fulfilling"]
export const shippedFulfillmentStatuses: FulfillmentStatusType[] = [ "shipping", "delayed", "incident", "delivered", "arrived", "review"]

export interface Fulfillment {
  id: string
  // orderId: string
  fulfilledToLocationId: string
  fulfilledByLocationId: string
  fulfillmentNumber: number
  // orderItems_on_fulfillment: OrderItem[]
  parcels_on_fulfillment: Parcel[]
  refunds_on_fulfillment: RefundPublic[]
  reviews_on_fulfillment?: ReviewForEdit[]
  refundInfo: FulfillmentRefundInfo
  order: {
    id: string
    orderNumber: number
    buyerId: string
    paymentTransactionId: string
    customerComments: string
    orderPlaced: number
    statusId: OrderStatusType
  }
  interactionId: string // i don't think this is right
  discounts_on_fulfillment: Discount[]
  fulfillmentDiscountAmount: number
  fulfillmentTotalAmount: number
  fulfillmentSalesTaxAmount: number
  fulfillmentSubTotalAmount: number
  fulfillmentFixedShippingAmount: number
  commissionAmount: number
  completionCode: string
  trackingNumber: string
  trackingUrl: string
  labelUrl: string
  shipmentIsBeingReconfigured: boolean
  shippingProcessorId: string
  shippingTransactionId: string
  rateCharged: number
  rateCost: number
  rateId?: string
  shippedDate: number
  payoutStatusId: PayoutStatusType
  fulfillmentDate: number
  statusId: FulfillmentStatusType;
  nextStatusActionDue: number
  createdAt: number
}

export interface TruncatedOrderItemForFulfillmentUpdateBeforeShipping {
  id: string 
  rateCost: number
  rateCharged: number
  fixedShippingCost?: number
  quantity: number
  pricePerItemAtTimeOfOrder: number
  parcelId: string
  fulfillmentId: string
  listingVariation: {
    listing: { 
      shippingCost: number
      shippingAdditionalCost: number
      category?: {
        taxCode: string
      }
    }
  }
}

export interface Reimbursement {
  id: string
  fulfillmentId: string
  orderId: string
  amount: number
  reason: string
  processorRefundId: string
  reimbursedAt: number
  reimbursedBy: string
  statusId: "initiated" | "pending" | "processing" | "completed" | "failed"
}